import { h } from 'preact'

import cx from 'classnames'

import style from './style.module.css'

function SwitchBtn({ onClick, isAccept, disabled }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={cx(style.switchBtn, {
        [style.switchBtnActive]: isAccept,
      })}>
      {isAccept ? 'เปิด' : 'ปิด'}
    </button>
  )
}

export default SwitchBtn
